// Web replacement for the part of react-native-blob-util the app uses:
// download to a "cached file" (an object URL here) with progress, then unlink it.
import { registerFile, releaseUri } from '../fileRegistry';

type ProgressListener = (received: number, total: number) => void;

function download(url: string) {
  let onProgress: ProgressListener | undefined;

  const run = async () => {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Download failed: ${response.status}`);
    const total = Number(response.headers.get('content-length')) || 0;
    const reader = response.body?.getReader();
    let blob: Blob;
    if (reader && total) {
      const chunks: BlobPart[] = [];
      let received = 0;
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        onProgress?.(received, total);
      }
      blob = new Blob(chunks, { type: response.headers.get('content-type') ?? undefined });
    } else {
      blob = await response.blob();
    }
    const uri = registerFile(blob);
    return { path: () => uri, blob: () => blob };
  };

  // Start on the next tick so `.progress()` can be attached first.
  const promise = Promise.resolve().then(run) as Promise<{ path: () => string; blob: () => Blob }> & {
    progress: (listener: ProgressListener) => typeof promise;
  };
  promise.progress = listener => {
    onProgress = listener;
    return promise;
  };
  return promise;
}

const ReactNativeBlobUtil = {
  fs: {
    dirs: { CacheDir: '', DocumentDir: '', DownloadDir: '' },
    async unlink(path: string) {
      releaseUri(path);
    },
  },
  config(_options: unknown) {
    return { fetch: (_method: string, url: string) => download(url) };
  },
};

export default ReactNativeBlobUtil;
